import type { Reducer } from 'redux';
import type { ClassLanguageAction } from './classLanguagesReducer';
import { ClassLanguageActionTypes } from './classLanguagesReducer';

type ToastState = {
  showing: boolean;
  messageId: string;
};

enum ToastMessageId {
  UserError = 'UserErrorToast',
  ApiError = 'ErrorToast',
}

export type ToastAction =
  | ReturnType<typeof showUserError | typeof showApiError | typeof toastClosed>
  | ClassLanguageAction;

enum ActionTypes {
  ShowUserError = 'members/settings/classLanguages/SHOW_USER_ERROR',
  ShowApiError = 'members/settings/classLanguages/SHOW_API_ERROR',
  ToastClosed = 'members/settings/classLanguages/TOAST_CLOSED',
}

export const toastReducer: Reducer<ToastState, ToastAction> = (
  state = { showing: false, messageId: '' },
  action,
) => {
  switch (action.type) {
    case ActionTypes.ShowUserError:
      return { showing: true, messageId: ToastMessageId.UserError };
    case ActionTypes.ShowApiError:
      return { showing: true, messageId: ToastMessageId.ApiError };
    case ActionTypes.ToastClosed:
      return { showing: false, messageId: '' };
    case ClassLanguageActionTypes.DisplayAllClasses:
    case ClassLanguageActionTypes.DisplayOnlySubtitles:
    case ClassLanguageActionTypes.ToggleIndividualSubtitle:
    case ClassLanguageActionTypes.DisableLanguage:
    case ClassLanguageActionTypes.EnableLanguage:
      return { ...state, showing: false };
    default:
      return state;
  }
};

export const showUserError = () =>
  ({
    type: ActionTypes.ShowUserError,
  } as const);

export const showApiError = () => ({ type: ActionTypes.ShowApiError } as const);

export const toastClosed = () =>
  ({
    type: ActionTypes.ToastClosed,
  } as const);
